/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: ofin-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var $jsToggles = document.querySelectorAll('.js-toggle');
function forEach(elements, callback) {
    [].forEach.call(elements, callback);
}
forEach($jsToggles, function(element) {
    var $titre = element.querySelector('.titre_toggle');
    $titre.addEventListener('click', function() {
        element.classList.toggle('js-toggle-active');
    });
});

(function() {
    var parcoursDiplomant = document.querySelector('.js-parcours_diplomant');
    if ( parcoursDiplomant && parcoursDiplomant !== null ) {
        parcoursDiplomant.querySelector('#DIPLOMANT_ETAPE').addEventListener('click', function () {
            document.querySelector('.js-parcours_diplomant .js-intitule-diplomant input[type="text"]').value = '';
            document.querySelector('.js-parcours_diplomant .js-intitule-diplomant').classList.toggle('masquer');
        });
    }
})();
